import styled from "styled-components";

export const Container = styled("div") <{ margin?: number, gutter?: number }>`
  ${(props) => {
    const { breakpoints } = props.theme;
    const { gutter, maxWidth, margin } = props.theme.grid;
    const thereIsGutter = props?.gutter !== undefined && props?.gutter >= 0;

    let styles = `
      width: 100%;
      padding-right: ${(thereIsGutter ? props.gutter : gutter) / 2}px;
      padding-left: ${(thereIsGutter ? props.gutter : gutter) / 2}px;
      margin-right: ${props.margin + "px" || "auto"};
      margin-left: ${props.margin + "px" || "auto"};

      @media ( max-width: 767px ) {
        padding-right: ${(thereIsGutter ? props.gutter : gutter) / 2}px;
        padding-left: ${(thereIsGutter ? props.gutter : gutter) / 2}px;
      }
      `;

    Object.keys(breakpoints).forEach((breakpoint) => {
      styles += `
        @media ( min-width: ${breakpoints[breakpoint]}px ) {
          max-width: ${maxWidth[breakpoint]};
        }
      `;
    });

    return styles;
  }}
`;
